/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

const API_BASE = environment.apiUrl;

export interface ArchetypeReportDiscount {
  _id: string;
  name: string;
  discountType: {
    identifier: string;
    name: string;
  };
  discountAmountBps: number;
  licensingPartner?: any;
  maxUses?: number;
  currentUses: number;
  expiresAt?: string | Date;
  isActive: boolean;
  onePerUser?: boolean;
  usedByUserIds?: string[];
  refreshOnly?: boolean;
  // Computed for display
  _discountAmountString?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ArchetypeReportDiscountService {
  constructor(private http: HttpClient) {}

  /**
   * Get all discounts (super admin only)
   */
  getAll(): Observable<ArchetypeReportDiscount[]> {
    return this.http.get<ArchetypeReportDiscount[]>(
      `${API_BASE}archetypeReportDiscounts`,
      { withCredentials: true }
    );
  }

  /**
   * Get a discount by ID
   */
  get(discountId: string): Observable<ArchetypeReportDiscount> {
    return this.http.get<ArchetypeReportDiscount>(
      `${API_BASE}archetypeReportDiscounts/${discountId}`,
      { withCredentials: true }
    );
  }

  /**
   * Look up a discount by name (for checkout validation)
   */
  getByName(name: string): Observable<ArchetypeReportDiscount | null> {
    return this.http.get<ArchetypeReportDiscount | null>(
      `${API_BASE}archetypeReportDiscounts/byName/${encodeURIComponent(name)}`,
      { withCredentials: true }
    );
  }

  /**
   * Create a new discount (super admin only)
   */
  create(discount: Partial<ArchetypeReportDiscount>): Observable<ArchetypeReportDiscount> {
    return this.http.post<ArchetypeReportDiscount>(
      `${API_BASE}archetypeReportDiscounts`,
      discount,
      { withCredentials: true }
    );
  }

  /**
   * Update a discount (super admin only)
   */
  update(discountId: string, updates: Partial<ArchetypeReportDiscount>): Observable<ArchetypeReportDiscount> {
    return this.http.post<ArchetypeReportDiscount>(
      `${API_BASE}archetypeReportDiscounts/${discountId}`,
      updates,
      { withCredentials: true }
    );
  }

  /**
   * Delete a discount (super admin only)
   */
  remove(discountId: string): Observable<void> {
    return this.http.delete<void>(
      `${API_BASE}archetypeReportDiscounts/${discountId}`,
      { withCredentials: true }
    );
  }
}
